export const PLATFORM_ANDROID = 1;
export const PLATFORM_IOS = 2;
export const PLATFORM_WEB = 3;

export const PLATFORM_MOBILE_APP = 5;
export const PLATFORM_WEB_MOBILE = 6;
export const PLATFORM_WEB_TABLET = 6;
